import { render } from "./TranscriptAnalysisModal.vue?vue&type=template&id=58589c26&scoped=true"
import script from "./TranscriptAnalysisModal.vue?vue&type=script&lang=js"
export * from "./TranscriptAnalysisModal.vue?vue&type=script&lang=js"

import "./TranscriptAnalysisModal.vue?vue&type=style&index=0&id=58589c26&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58589c26"]])

export default __exports__